import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
import './SolutionsPage.css'
import {  
  Link
} from "react-router-dom";


function SolutionsPage(){
  return(
    <main className="max-w-6xl mx-auto px-4 py-12 space-y-16" style={{maxWidth: "1102px"}}>
      <br></br>
      <section className="text-center">
    <div className="mt-8 flex justify-center">
      <img 
        src="/solutions1.webp" 
        alt="Solutions Icons" 
        className="img-fluid-rounded-shadow" 
        style={{ maxWidth: "100%", maxHeight: "500px", padding : "16px",border: "0.1px solid #D8D8D8", 
          borderRadius: "20px" }} 
      />
       <style>{`
  .img-fluid-rounded-shadow {
  
    display: block;
    margin: 0 auto;
    opacity: 0;
    transform: translateY(30px);
    animation: fadeInUp 1s ease-out forwards;
    animation-delay: 0.3s;
  }

  @keyframes fadeInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`}</style>
    </div>
  </section>
  <br></br>
  
  <p className="text-center text-gray-300 mt-6 px-4 max-w-[890px] mx-auto text-base" style={{fontSize : "24px", fontWeight : "400",lineHeight : "140%",letterSpacing : "0px", color : "#fff", maxWidth: "1069px", maxHeight : "136px"
  }}>
  We translate visionary possibilities into tangible realities. Our solutions are more than just technology; they are meticulously crafted engines designed to power your evolution within the demanding landscapes of Telecommunications (OSS) and Financial Services. We don't just address challenges – we anticipate them, turning complexity into your strategic advantage.
  </p>
  <br></br>
  <hr style={{ borderTop: "1px solid #fff",  width: "1070px", margin: "20px auto 0 auto" }} />
  <br></br>
  
  <section className="max-w-[1102px] mx-auto">
  <div className="grid md:grid-cols-2 gap-8 items-center" style={{display : "flex",maxWidth: "1070px", maxHeight : "322.74px", justifyContent : "space-between"}}>

    <div className="ignite-digital" style={ {maxWidth : "507px", maxHeight : "237px",  paddingTop: "60px"}}>
      <h2 className="ignite-title text-xl mb-4" style={{fontWeight : "700", fontSize : "22px", lineHeight : "28px", letterSpacing : "0px"
      }}>Ignite Digital Acceleration</h2>
      <p className="text-gray-300 text-sm leading-relaxed" style={{fontSize : "16px", fontWeight : "400", lineHeight : "27px", letterSpacing : "0px",color : "#fff"}}>
      Leapfrog the competition with transformative solutions that streamline operations, enhance customer engagement, and build agile foundations for future growth. We guide your digital journey from concept to seamless execution.
      </p>
    </div>

    <div
    style={{maxWidth: "438px" , maxHeight : "322.74px"}}>
      <img 
        src="/sol2.webp" 
        alt="Digital Transformation" 
        className="rounded-lg w-full h-auto object-cover"
        style={{ maxWidth: "100%", maxheight: "100%", borderRadius : "21.28px" }} />
    </div>
  </div>
</section>
<br></br>
<hr style={{ borderTop: "1px solid #fff", marginTop: "20px", width: "1070px", margin: "40px auto 0 auto" }} />
  <br></br>
  <section className="max-w-[1102px] mx-auto ">
  <div className="grid md:grid-cols-2 gap-8 items-center" style={{display : "flex",maxWidth: "1070px", maxHeight : "322.74px", justifyContent : "space-between"}}>
   

 
    <div
    style={{maxWidth: "438px" , maxHeight : "322.74px"}}>
      <img 
        src="/sol3.webp" 
        alt="Telecommunication" 
        className="rounded-lg w-full h-auto object-cover"
        style={{ maxWidth: "100%", maxheight: "100%", borderRadius : "21.28px", marginRight: "40px", paddingRight: "50px" }} />
    </div>
    <div style={ {maxWidth : "592px", maxHeight : "236px", gap : "40px", paddingTop: "60px"}}>
      <h2 className="text-xl  mb-4" style={{fontWeight : "700", fontSize : "28px", lineHeight : "28px", letterSpacing : "0px"
      }}>Master Telecom Complexity (OSS)</h2>
      <br></br>
      <p className="text-gray-300 text-sm leading-relaxed" style={{fontSize : "16px", fontWeight : "400", lineHeight : "24px", letterSpacing : "0px",color : "#fff"}}>
      Navigate the intricate world of network operations with unparalleled clarity and control. Our specialized OSS solutions optimize performance, automate critical processes, and unlock the intelligence needed for superior service delivery and efficient scaling in the 5G era and beyond.
      </p>
    </div>
  </div>
</section>
<br></br>
<hr style={{ borderTop: "1px solid #fff", marginTop: "20px", width: "1070px", margin: "40px auto 0 auto" }} />
  <br></br>
<section className="max-w-[1102px] mx-auto">
  <div className="grid md:grid-cols-2 gap-8 items-center" style={{display : "flex",maxWidth: "1070px", maxHeight : "399.76px", justifyContent : "space-between"}}>

    <div style={ {maxWidth : "592px", maxheight : "188px", gap : "40px", paddingTop : "80px"}}>
      <h2 className="text-xl font-semibold mb-4" style={{fontWeight : "700", fontSize : "28px", lineHeight : "28px", letterSpacing : "0px"
      }}>Innovate Financial Frontiers</h2>
      <br></br>
      <p className="text-gray-300 text-sm leading-relaxed" style={{fontSize : "16px", fontWeight : "400", lineHeight : "24px", letterSpacing : "0px",color : "#fff"}}>
      Build trust, ensure compliance, and drive growth in the dynamic financial sector. We deliver secure, robust, and customer-centric platforms that modernize core systems, mitigate risk, and enable the next generation of digital financial services.
      </p>
    </div>

    <div
    style={{maxWidth: "438px" , maxHeight : "399.76px"}}>
      <img 
        src="/sol4.webp" 
        alt="Financial Services & Banking Solutions" 
        className="rounded-lg w-full h-auto object-cover"
        style={{ maxWidth: "100%", maxheight: "100%", borderRadius : "20.86px" }} />
    </div>
  </div>
  </section>
  <br></br>
  <hr style={{ borderTop: "1px solid #fff", marginTop: "20px", width: "1070px", margin: "40px auto 0 auto" }} />
  <br></br>
  <br></br>
  <div
  style={{
    backgroundImage: "url('/changerlast.webp')", // Buraya kendi arka plan görselinin yolu
    backgroundSize: "cover",
    backgroundPosition: "center",
    paddingTop: "16px",
    paddingBottom: "16px",
    borderRadius: "20px",
    maxWidth: "1070px",
    height: "512px",
    display: "flex",
    margin: "0 auto",
    color: "#fff",
    alignItems: "center",
    justifyContent : "center"
  }}
>
<div
    style={{
      width: "848px",
      borderRadius: "40px",
      padding: "40px",
      backgroundColor: "rgba(255, 255, 255, 0.01)", // Beyaz ama çok şeffaf
      backdropFilter: "blur(1px)",
      WebkitBackdropFilter: "blur(2px)",
      color: "#fff",
      textAlign: "left"
    }}
  >
    <h2 style={{ fontSize: "48px", fontWeight: "700" }}>
      Let’s Grow Together
    </h2>
    <br></br>
    <p style={{ fontSize: "16px", lineHeight: "24px", letterSpacing: "0px", color: "#fff"}}>
    Built on a foundation of trust and forward-thinking, every Briospark solution is engineered for reliability, security, and sustained success. Partner with us to redefine what's possible for your organization.
    </p>
    <br></br>
    <Link to="/contactus" onClick={() => window.scrollTo(0, 0)}>
    <button
      style={{
        backgroundColor: "#2563eb",
        color: "#fff",
        padding: "12px 24px",
        border: "none",
        borderRadius: "20px",
        fontSize: "14px",
        fontWeight: "500",
        cursor: "pointer"
      }}
    >
      Let’s Grow Together
    </button>
    </Link>
  </div>
</div>
  </main>
  );
}
export default SolutionsPage;